import { tns } from 'tiny-slider'
import { registerComponent } from './components-front'

registerComponent('universal-grid', _ => {
    document.querySelectorAll('.universal-grid-slider-item .slider').forEach(slider => {
        tns({
            container: slider,
            items: 1,
            slideBy: 1,
            controls: false,
            navPosition: 'bottom',
            autoplay: true,
            autoplayButtonOutput: false,
        })
    })

    document.querySelectorAll('.modal-trigger').forEach(trigger => {
        trigger.addEventListener('click', _ => {
            const target = document.querySelector(trigger.dataset.target)
            if (target) {
                target.classList.add('show')
                target.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
                const scrollY = document.documentElement.style.getPropertyValue('--scroll-y')
                const body = document.body
                body.style.position = 'fixed'
                body.style.top = `-${scrollY}`
                // target.firstElementChild.style.top = `${scrollY}`

                const close = _ => {
                    if (target.classList.contains('show')) {
                        const scrollY = body.style.top
                        body.style.position = ''
                        body.style.top = ''
                        scrollTo(0, parseInt(scrollY || '0') * -1)
                        target.classList.remove('show')
                        // target.style.backgroundColor = ''
                    }
                }

                target.querySelector('button.close').addEventListener('click', _ => {
                    close()
                })

                target.addEventListener('click', _ => {
                    close()
                })

                target.firstElementChild.addEventListener('click', ev => {
                    ev.stopPropagation()
                })
            }
        })
    })

    addEventListener('resize', _ => {
        if (window.innerWidth > 991) {
            document.querySelectorAll('.modal.show .modal-header .close').forEach(close => {
                close.click();
            });
        }
    })

    addEventListener('scroll', _ => {
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`)
    })
})
